import React, { createContext, useContext, useState, useEffect } from "react";
import API_BASE from "./apiConfig";

/*
  AppContext.js — global config store
  ─────────────────────────────────────────────────────────────
  Loads the app_config row from the backend on mount.
  All components that need branding/org data consume useAppConfig().

  Config shape (mirrors the DB defaults):
  {
    org_name:           "Sixers Sports Center",
    org_tagline:        "Athlete management platform for coaches, staff and administrators",
    org_email:          "",
    org_phone:          "",
    org_address:        "",
    logo_url:           "",          // if empty → fall back to Sixers_Logo.png
    primary_color:      "#034e7b",
    secondary_color:    "#f7ce0b",
    accent_color:       "#023a5c",
    sidebar_opacity:    "0.50",
    font_family:        "Segoe UI",
    date_format:        "MM/DD/YYYY",
    time_format:        "12h",
    timezone:           "America/New_York",
    currency:           "USD",
    report_header:      "",
    report_footer:      "Confidential — Sixers Sports Center",
    report_show_logo:   true,
    report_color_scheme:"blue",
    items_per_page:     "25",
    session_timeout:    "60",
    maintenance_mode:   false,
  }
*/

const DEFAULT_CONFIG = {
  org_name:           "Sixers Sports Center",
  org_tagline:        "Athlete management platform for coaches, staff and administrators",
  org_email:          "",
  org_phone:          "",
  org_address:        "",
  logo_url:           "",
  primary_color:      "#034e7b",
  secondary_color:    "#f7ce0b",
  accent_color:       "#023a5c",
  sidebar_opacity:    "0.50",
  font_family:        "Segoe UI",
  date_format:        "MM/DD/YYYY",
  time_format:        "12h",
  timezone:           "America/New_York",
  currency:           "USD",
  report_header:      "",
  report_footer:      "Confidential — Sixers Sports Center",
  report_show_logo:   true,
  report_color_scheme:"blue",
  items_per_page:     "25",
  session_timeout:    "60",
  maintenance_mode:   false,
};

const AppContext = createContext({ config: DEFAULT_CONFIG, reloadConfig: () => {} });

export function AppProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  const loadConfig = async () => {
    try {
      const res  = await fetch(`${API_BASE}/config/`);
      const data = await res.json();
      if (data.config) setConfig({ ...DEFAULT_CONFIG, ...data.config });
    } catch {
      // server unreachable — keep defaults, app still works
    }
  };

  useEffect(() => { loadConfig(); }, []);

  return (
    <AppContext.Provider value={{ config, reloadConfig: loadConfig }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppConfig() {
  return useContext(AppContext);
}

export default AppContext;
